import React, { useEffect } from 'react';
import { Row, Col, ButtonGroup, Button, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import { Redirect, Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Utils } from '../../../services';

import PageTitle from '../../../components/PageTitle/PageTitle';
import { loadChannel, deleteChannel } from '../../../redux/modules/channels';

const ChannelDelete = ({ match }) => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();
    const default_lang = Utils.default_lang();

    useEffect(() => {
        const postCategoryId = match.params.channelId;
        dispatch(loadChannel(postCategoryId));
    }, [dispatch])

    const _deletePostCategory = (postCategoryId) => {
        dispatch(deleteChannel(postCategoryId));
    }

    const { channel, isLoading, channelSuccessfullyDeleted } = useSelector(state => state.channels);

    let title = <span>{t("channels.channel", {count: 42})}</span>;
    if (channel && channel.name)
        title = (
            <span>
                {t("channels.channel", {count: 1})}
                <small> | { channel.name } </small>
            </span>
        );

    const actions =
    <div>
        <ButtonGroup>
            <Button tag={Link} to="/channels" color="warning" size="sm">
                <i className="fa fa-arrow-left"></i>&nbsp;{t("common.back")}
            </Button>
        </ButtonGroup>
    </div>

    return (
        <div className="ChannelDelete">
            <PageTitle icon="tags" title={ title } actions={ actions } />
            {channelSuccessfullyDeleted &&
                <Redirect to="/channels"/>
            }

            {channel && channel.name &&
                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle><i className="fa fa-warning"></i>&nbsp;{ t('channels.confirm_delete')}</CardTitle>
                                <CardText tag="div">
                                    <div><b>{t("channels.name")}</b>: { channel.name }</div>
                                    <div><b>{t("channels.slug")}</b>: { channel.slug }</div>
                                    <Row>
                                        <Col className="text-center">
                                            <Button tag={Link} to="/channels" color="warning">
                                                <i className="fa fa-arrow-left"></i>&nbsp;{ t('common.cancel')}
                                            </Button>&nbsp;
                                            <Button color="danger" onClick={(e) => _deletePostCategory(channel.id)} disabled={isLoading}>
                                                {isLoading ?
                                                    <span>
                                                        &nbsp;<i className="fa fa-spinner fa-spin"></i>
                                                    </span>
                                                    :
                                                    <span>
                                                        <i className="fa fa-trash"></i>&nbsp;
                                                        { t('common.delete')}
                                                    </span>
                                                }
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardText>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            }
            </div>
    );
}

export default ChannelDelete
